import clsx from 'clsx';

import styles from './Button.module.scss';

type ButtonProps = {
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
    'aria-label'?: string;
    disabled?: boolean;
};

const Button = ({children, className, onClick, disabled, ...rest}: ButtonProps) => {
    return (
        <button
            type='button'
            className={clsx(styles.Button, className)}
            onClick={onClick}
            disabled={disabled}
            {...rest}
        >
            {children}
        </button>
    );
};

export default Button;
